import { ChangeDetectionStrategy, Component, ElementRef, afterNextRender, input, output, viewChild } from '@angular/core';

import { LinkComponent } from '@teamfoster/sdk/button';
import { IconComponent } from '@teamfoster/sdk/icon';
import { MenuItem, OfMenuTypePipe } from '@teamfoster/sdk/menu-ngrx';

@Component({
    selector: 'app-topbar-nav-list',
    imports: [LinkComponent, IconComponent, OfMenuTypePipe],
    templateUrl: './topbar-nav-list.component.html',
    styleUrl: './topbar-nav-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopbarNavListComponent {
  page = input<MenuItem>();
  closeOverlay = output<void>();

  readonly list = viewChild<ElementRef>('list');
  collapsed = true;
  listHeight = '100px';

  constructor() {
    afterNextRender(() => {
      this.listHeight = `${this.list()?.nativeElement.getBoundingClientRect().height}px`;
    });
  }
}
